export enum SalesItemAttributeProcessingType {
  NoProcessing = 1,
  SaveasPetRabiesTag = 2,
  SaveasPetMicrochip = 3,
  TestResult = 4,
}
